// extracted by mini-css-extract-plugin
export default {"cancelIcon":"cancelQuoteBtn_cancelIcon__g7ril","quoteCancelBtn":"cancelQuoteBtn_quoteCancelBtn__CUgqB"};